export interface ClipboardModel {
    modelId: number;
    sortOrder: number;
}

export const copyModelsToClipboard = async (
    models: ClipboardModel[],
) => {
    await navigator.clipboard.writeText(
        JSON.stringify({
            type: 'PATH_MODELS',
            version: 1,
            models,
        }),
    );
};

export const pasteModelsFromClipboard =
    async (): Promise<
        ClipboardModel[]
    > => {
        const text =
            await navigator.clipboard.readText();
    let data: any;
    try {
        data = JSON.parse(text);
    } catch (err) {
        throw new Error('Clipboard content is not valid JSON.');
    }

    if (
        data?.type !== 'PATH_MODELS'
    ) {
        throw new Error(
            'Clipboard does not contain models',
        );
    }
    if (!Array.isArray(data.models)) {
        return [];
    }

    return data.models || [];
};